import { light as lightOrange, dark as darkOrange } from "./theme_palatte";

const palette = (themeMode = "light") => {
  return themeMode === "dark" ? darkOrange : lightOrange;
};

export default palette;
